const initialState = [
  {
    currentRef: [],
    ErrorData: {},
  },
];

const videojsReducer = (state = initialState, action) => {
  switch (action.type) {
    case "VIDEOJS_CURRENT_REF":
      return {
        ...state,
        currentRef: action.payload,
      };

    case "VIDEO_PLAYER_ERROR":
      return {
        ...state,
        ErrorData: action.payload,
      };
    default:
      return state;
  }
};

export default videojsReducer;
